import React from 'react';
import { UserPlus } from 'lucide-react';
import { INVITE_MEMBER_STRINGS, useMetaLang } from '../../i18n/metaReviewLang';

export interface InviteMemberButtonProps {
  isLeader: boolean;
  onClick: () => void;
}

const InviteMemberButton: React.FC<InviteMemberButtonProps> = ({ isLeader, onClick }) => {
  const [lang] = useMetaLang();
  const t = INVITE_MEMBER_STRINGS[lang];
  if (!isLeader) {
    return null;
  }

  return (
    <button
      type="button"
      onClick={onClick}
      className="flex items-center gap-1.5 text-[12px] font-bold text-primary bg-primary/5 hover:bg-primary/10 rounded-full px-3.5 py-1.5 transition"
      aria-label={t.invite}
    >
      <UserPlus className="w-3.5 h-3.5" />
      <span>{t.invite}</span>
    </button>
  );
};

export default InviteMemberButton;
